import React from 'react';
import { Modal, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import "./Svg.css";


function SvgEPS({x, y, Combinations }) {
    const { t, i18n } = useTranslation();

    // let InverterConnectionMode = 1;
    let PAC1EPS = 0; 
    let PAC2EPS = 0; 
    let PAC3EPS = 0; 
    let rows = [];
    let c1 = 0;
    let c2 = 0;
    let c3 = 0;

    if (Combinations != null) {
        Combinations.forEach((item, index) => {
            PAC1EPS += parseInt(item.PAC1EPS) * 0.0001;
            PAC2EPS += parseInt(item.PAC2EPS) * 0.0001;
            PAC3EPS += parseInt(item.PAC3EPS) * 0.0001;
            c1++;
            c2++;
            c3++;

            rows.push({
                SN: item.SN,
                CreateTime: item.CreateTime,
                PAC1EPS: item.PAC1EPS != null ? (parseInt(item.PAC1EPS) * 0.0001).toFixed(3) : "",
                PAC2EPS: item.PAC2EPS != null ? (parseInt(item.PAC2EPS) * 0.0001).toFixed(3) : "",
                PAC3EPS: item.PAC3EPS != null ? (parseInt(item.PAC3EPS) * 0.0001).toFixed(3) : "",
            });
        });
    }
    

    const handleClick = () => {
        Modal.info({
            maskClosable: true,
            width: "1000px",
            icon: null,
            title: t("EPS Data"),
            content: (<Table 
                pagination={false}
                columns={[
                    { title: t("Inverter SN"), dataIndex: "SN",  align: "right",render: (v,r) => {
                        return `${v}${r.Phase === 2 ? "(A)" : r.Phase === 3 ? "(B)" : r.Phase === 4 ? "(C)" : ""}`;
                    } },
                    { title: t("DataTime"), dataIndex: "CreateTime",  align: "right" },
                    { title: t("PAC1EPS")+"(kW)", dataIndex: "PAC1EPS",  align: "right" },
                    { title: t("PAC2EPS")+"(kW)", dataIndex: "PAC2EPS",  align: "right" },
                    { title: t("PAC3EPS")+"(kW)", dataIndex: "PAC3EPS",  align: "right" },
                ]}
                dataSource={rows}
            />),
            onOk() {
            },
        });
    };

    let count = Combinations?.length || 0;

    return (<svg xmlns="http://www.w3.org/2000/svg">
        <svg cursor={"pointer"} x={x+10} y={y} width={90} height={80}  version="1.1" viewBox="0 0 1109 1024"
             onClick={handleClick}
        >
            <path fill="#1d80b5" d="M1066.667 341.333H1024v405.334a149.333 149.333 0 0 1-298.667 0v-448A42.667 42.667 0 0 0 682.667 256v682.667H768V1024H0v-85.333h85.333V85.333A85.333 85.333 0 0 1 170.667 0h426.666a85.333 85.333 0 0 1 85.334 85.333v85.334a128 128 0 0 1 128 128v448a64 64 0 0 0 128 0V341.333H896a42.667 42.667 0 0 1-42.667-42.666v-85.334A42.667 42.667 0 0 1 896 170.667v-21.334a21.333 21.333 0 0 1 42.667 0v21.334H1024v-21.334a21.333 21.333 0 0 1 42.667 0v21.334a42.667 42.667 0 0 1 42.666 42.666v85.334a42.667 42.667 0 0 1-42.666 42.666zM341.333 810.667L512 640H384V512L256 682.667h128z m256-682.667H170.667v256h426.666V128zM1024 213.333h-85.333a42.667 42.667 0 0 0 0 85.334H1024a42.667 42.667 0 0 0 0-85.334z"></path>
        </svg>
        
        <svg x={x + 90 + 10} y={y+84 - 120} >
            <text x={i18n.language === "en" ? 110: 110} y={30} fontSize="20" fill="black" textAnchor="end">
                {PAC1EPS.toFixed(3)} kW
                {count>1&&<tspan dy="-1.2em" className='sigma'>(Σ{c1})</tspan>}
            </text>
            <text x={i18n.language === "en" ? 110: 110} y={60} fontSize="20" fill="black" textAnchor="end">{PAC2EPS.toFixed(3)} kW{count>1&&<tspan dy="-1.2em" className='sigma'>(Σ{c2})</tspan>}</text>
            <text x={i18n.language === "en" ? 110: 110} y={90} fontSize="20" fill="black" textAnchor="end">{PAC3EPS.toFixed(3)} kW{count>1&&<tspan dy="-1.2em" className='sigma'>(Σ{c3})</tspan>}</text>
            <text x={i18n.language === "en" ? 110: 110} y={120} fontSize="20" fill="black" textAnchor="end">{t("EPS")}</text>
        </svg>
        
        
    </svg>)
}

export default SvgEPS